export class AulaVisualizacao {
  id: number;
  nome: string;
  codigoVimeo: string;
  codigoVimeoMobile: string;
  continuarOndeParou: number;
  proximaAulaId: number;
}
